// Renders individual chat messages by dispatching to role-specific components.
import React from 'react';
import { Message, ChatFile, MessageCitation } from '../../types/chat';
import { UserMessage } from './UserMessage';
import { LemaMessage } from './LemaMessage';

interface ChatMessageProps {
  message: Message;
  files: ChatFile[];
  isLastAssistantMessage: boolean;
  scrollToMessage: (messageId: string) => void;
  onCitationClick?: (citation: MessageCitation) => void;
  onShowCitations?: (citations: MessageCitation[]) => void;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({
  message,
  files,
  isLastAssistantMessage,
  scrollToMessage,
  onCitationClick,
  onShowCitations,
}) => {
  const isUser = message.role === 'user';

  if (isUser) {
    return (
      <UserMessage
        message={message}
        files={files}
        scrollToMessage={scrollToMessage}
      />
    );
  }

  return (
    <LemaMessage
      message={message}
      files={files}
      isLastAssistantMessage={isLastAssistantMessage}
      scrollToMessage={scrollToMessage}
      onCitationClick={onCitationClick}
      onShowCitations={onShowCitations}
    />
  );
};
 